<template>
  <ColumnWithHelp
    :label="label"
    sortable
    :resizable="false"
    :min-width="130"
    :title="label"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_IMPRESSIONS_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { impressionCount } }">
      {{ priceFormat(impressionCount) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'ImpressionColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    priceFormat,
  },
};
</script>
